function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, $hooks, Array, JSON, Object, String, eventData, getSortedMenuSections, isHeaderMenuOpen, isMenuOpen, openModal, searchFilter, tooltipData) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['block-selector'] = function(isMenuOpen) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const selectorIcon = $attr(`selector-icon`) || $helpers.selectedIcon();;
        __jade_nodes = __jade_nodes.concat((selectorType === `button` || $attr(`theme`) === `select`) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "key": JSON.stringify($attr(`selected`)) + selectedLabel,
            "attrs": __vjadeStringifyAttrsIfObj({
              disabled: $attr(`disabled`),
              icon: selectorIcon || ``,
              theme: selectorTheme,
              pressed: isMenuOpen,
            }),
            "class": {
              'truncated': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($attr(`prefix-label`));
            __jade_nodes = __jade_nodes.concat(selectedLabel);
            __jade_nodes = __jade_nodes.concat(block && block());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = []; /*  block label */
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'is-disabled': $attr(`disabled`),
              'is-editing': $helpers.showInput() && isMenuOpen,
              [`is-theme-${selectorTheme}`]: true,
            }, {
              'mp-query-menu-label': true
            }),
          }, (function() {
            var __jade_nodes = []; /*  selector icon */
            __jade_nodes = __jade_nodes.concat((selectorIcon) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: selectorIcon
                }),
              }));;
              return __jade_nodes
            }).call(this)) : undefined); /*  selector label */
            __jade_nodes = __jade_nodes.concat(selectedLabel);
            __jade_nodes = __jade_nodes.concat(block && block());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const customEvents = eventData && eventData.filter(event => !!event.id);;
    const canWriteCustomEvents = $helpers.canWriteCustomEvents();;
    const canWriteCustomProperties = $helpers.canWriteCustomProperties();;
    const selectorType = $attr(`selector-type`);;
    const selectorTheme = $helpers.getSelectorTheme();;
    const selectedLabel = $helpers.showInput() ? $helpers.selectedLabel() || $attr(`label`) : $attr(`label`);;
    const prefixLabel = $attr(`prefix-label`) || $helpers.getPrefixLabel();;
    const headerSegments = $helpers.getHeaderSegments();;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'has-prefix-label': prefixLabel,
          'has-header-segments': headerSegments.length,
          [`mp-query-theme-${selectorTheme}`]: true,
        }, {
          'mp-query-block': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-block-header-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (headerSegments);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, segment, $index) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((((segment.type) == (`text`))) ?
                    ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-query-block-header-segment-label': true
                        },
                      }, [__vjadeSafeCode(segment.value)]));;
                      return __jade_nodes
                    }).call(this)) :
                    (((segment.type) == (`select`))) ?
                    ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-query-block-header-drop-menu': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            open: isHeaderMenuOpen
                          }),
                          "on": {
                            change: $helpers.handleHeaderMenuVisibilityChange
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              sections: JSON.stringify($helpers.getHeaderMenuSection(segment))
                            }),
                            "on": {
                              clickItem: $helpers.handleHeaderSelectionChanged
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: $helpers.handleHeaderSelectClicked
                        },
                        "class": {
                          'mp-query-block-header-segment-selector-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(segment.selectedItem.label);
                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            icon: 'caret-down'
                          }),
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) :
                    undefined);;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var $index = $$objKey;
                  if ($$obj.hasOwnProperty($index)) {
                    $$iterated = true;
                    var segment = $$obj[$index];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((((segment.type) == (`text`))) ?
                        ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-query-block-header-segment-label': true
                            },
                          }, [__vjadeSafeCode(segment.value)]));;
                          return __jade_nodes
                        }).call(this)) :
                        (((segment.type) == (`select`))) ?
                        ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-query-block-header-drop-menu': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                open: isHeaderMenuOpen
                              }),
                              "on": {
                                change: $helpers.handleHeaderMenuVisibilityChange
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  sections: JSON.stringify($helpers.getHeaderMenuSection(segment))
                                }),
                                "on": {
                                  clickItem: $helpers.handleHeaderSelectionChanged
                                },
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              click: $helpers.handleHeaderSelectClicked
                            },
                            "class": {
                              'mp-query-block-header-segment-selector-label': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(segment.selectedItem.label);
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                icon: 'caret-down'
                              }),
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) :
                        undefined);;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })()); /*  information label */
          __jade_nodes = __jade_nodes.concat(($attr(`help-text`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'header-info': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `info`
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "class": {
                  'help-text': true
                },
              }, [__vjadeSafeCode($attr(`help-text`))]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  .mp-query-block-unit */
        __jade_nodes = __jade_nodes.concat((selectorType !== `button` && prefixLabel) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-block-unit': true,
              'mp-query-block-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(prefixLabel);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: !$helpers.isReadOnly() && $helpers.handleLabelClick,
          },
          "class": Object.assign({}, {
            'mp-query-editing': $helpers.showInput() && isMenuOpen
          }, {
            'mp-query-block-selector': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((tooltipData && !isMenuOpen && !openModal) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
              "hook": {
                remove: $hooks.delayedAttrRemove(`tooltip-data`, null)
              },
              "attrs": __vjadeStringifyAttrsIfObj({
                'tooltip-data': JSON.stringify(tooltipData),
                'position-parent-selector': `.mp-query-block-selector`,
                placement: `bottom`,
              }),
              "on": {
                hoverIn: $helpers.handleContextPanelHoverIn,
                hoverOut: $helpers.handleContextPanelHoverOut,
                tooltipContextAction: $helpers.handleTooltipContextAction,
                tooltipContextEditDescription: $helpers.handlePropagatedtooltipContextEditDescription,
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined); /*  The mouseenter and mouseleave events must be on this element rather than the parent */
          /*  element, since the parent element includes the child menu. Placing these events on the */
          /*  parent element causes problems when hovering over the context panel from the child */
          /*  menu in some cases (e.g. for mp-events-menu) */
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: 'selectorLabel'
            }),
            "on": {
              mouseenter: $helpers.handleLabelMouseEnter,
              mouseleave: $helpers.handleLabelMouseLeave,
            },
            "class": {
              'mp-query-block-selector-inner': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['block-selector'].call({
              block: function() {
                return (function() {
                  var __jade_nodes = []; /*  remove button */
                  __jade_nodes = __jade_nodes.concat(($attr(`removable`)) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "on": {
                        click: $helpers.handleRemove
                      },
                      "class": {
                        'mp-query-block-remove-button': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: `circle-clear`
                        }),
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this);
              }
            }, isMenuOpen));
            __jade_nodes = __jade_nodes.concat($helpers.renderSelectedDateTooltipIfNeeded());;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              [`is-${$attr(`dropdown-alignment`)}-aligned`]: true
            }, {
              'mp-query-drop-menu-container': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.isReady()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  open: isMenuOpen,
                  'prevent-close-selectors': JSON.stringify($helpers.preventCloseSelectors()),
                }),
                "on": {
                  change: $helpers.handleMenuChange,
                  click: ev => ev.stopPropagation(),
                  /* clicks in the drop menu should not bubble up */
                },
                "class": {
                  'custom-width': $helpers.menuHasCustomWidth(),
                },
              }, (function() {
                var __jade_nodes = [];
                const childAttrs = {
                  attrs: $helpers.getChildMenuAttributes(),
                  on: {
                    selectAll: $helpers.handleSelectAll,
                    select: $helpers.handleSelect,
                    deletecustomproperty: $helpers.handleDeleteCustomProperty,
                    cancel: $helpers.handleCancel,
                    closedModal: $helpers.handleChildMenuClosedModal,
                    tooltipContextAction: $helpers.handlePropagatedTooltipContextAction,
                    tooltipContextEditDescription: $helpers.handlePropagatedtooltipContextEditDescription,
                  },
                  hook: {
                    insert: $helpers.menuInserted
                  },
                  props: {
                    tooltipPositionParentElement: $helpers.getTooltipPositionParentElement(),
                    getSortedMenuSections,
                  },
                };; /*  search filter */
                __jade_nodes = __jade_nodes.concat($helpers.isContentSearchable() ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'search-wrapper': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-input", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'icon': 'search',
                        'placeholder': $attr(`search-placeholder`) || 'Search',
                        elref: `searchInput`,
                      }),
                      "props": {
                        value: searchFilter
                      },
                      "on": {
                        input: $helpers.handleSearchInput
                      },
                      "hook": {
                        insert: $helpers.searchInputInserted
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined); /*  selection menu */
                __jade_nodes = __jade_nodes.concat($component.child($helpers.getChildMenuName(), childAttrs));
                __jade_nodes = __jade_nodes.concat(($helpers.showCreateCustomEvent()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                    "on": {
                      click: $helpers.handleCreateCustomEvent
                    },
                    "class": {
                      'mp-button-bar-secondary': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Create Custom Event");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  TODO: refactor mp-custom-event-modal to live inside mp-events-menu */
        __jade_nodes = __jade_nodes.concat((openModal === $helpers.MODAL_TYPE.CustomEvent && canWriteCustomEvents) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-custom-event-modal", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": __vjadeStringifyAttrsIfObj($helpers.filterAttributes({
              'all-data-groups': $attr(`all-data-groups`),
              'events': JSON.stringify(eventData),
              'is-blocked-people': $attr(`is-blocked-people`),
              'open': true,
              'project-has-people': $attr(`project-has-people`),
              'project-id': $attr(`project-id`),
              'selected-custom-event-id': $helpers.getSelectedCustomEventId(),
              'workspace-id': $attr(`workspace-id`),
              'project-as-of-date': $attr(`project-as-of-date`),
              'track-name': $attr(`track-name`),
            })),
            "on": {
              cancelEditingCustomEvent: $helpers.handleCloseModal,
              deletedCustomEvent: $helpers.deletedCustomEvent,
              modalClosed: $helpers.handleCloseModal,
              savedCustomEvent: $helpers.savedCustomEvent,
              track: $helpers.captureTracking,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "eventData" in locals ? locals.eventData : typeof eventData !== "undefined" ? eventData : undefined, "getSortedMenuSections" in locals ? locals.getSortedMenuSections : typeof getSortedMenuSections !== "undefined" ? getSortedMenuSections : undefined, "isHeaderMenuOpen" in locals ? locals.isHeaderMenuOpen : typeof isHeaderMenuOpen !== "undefined" ? isHeaderMenuOpen : undefined, "isMenuOpen" in locals ? locals.isMenuOpen : typeof isMenuOpen !== "undefined" ? isMenuOpen : undefined, "openModal" in locals ? locals.openModal : typeof openModal !== "undefined" ? openModal : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;